import { Navigate } from 'react-router-dom';

import LoadingScreen from 'src/components/loading-screen';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import { Roles } from 'src/types/User';

interface VoiceReceptionistOrganizationGuardProps {
  readonly children: React.ReactNode;
}

export default function VoiceReceptionistOrganizationGuard({
  children,
}: VoiceReceptionistOrganizationGuardProps): JSX.Element {
  const { isLoading, organizations, selectedOrganization, selectedRole } =
    useOrganizationContext();

  if (
    isLoading ||
    (selectedOrganization === null && organizations.length > 0)
  ) {
    return <LoadingScreen />;
  }

  const hasAccess =
    selectedOrganization !== null &&
    (selectedRole === Roles.organization_owner ||
      selectedRole === Roles.organization_admin);

  return hasAccess ? (
    <>{children}</>
  ) : (
    <Navigate to={PATH_DASHBOARD.general.calendar} replace />
  );
}
